import { useState, useEffect } from "react";

export default function useMedia(query) {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);
  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);
    mql.addEventListener?.('change', onChange) || mql.addListener(onChange);
    return () => {
      mql.removeEventListener?.('change', onChange) || mql.removeListener(onChange);
    };
  }, [query]);
  return matches;
}
